
import Vue from 'vue';

import BoxDemographicsGroupPie from '@/components/Box/Demographics/BoxDemographicsGroupPie.vue';
import BoxDemographicsGenderRate from '@/components/Box/Demographics/BoxDemographicsGenderRate.vue';
import BoxDemographicsTrends from '@/components/Box/Demographics/BoxDemographicsTrends.vue';
import GenderTable from '@/components/zoneReport/GenderTable.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  components: {
    BoxDemographicsGenderRate,
    BoxDemographicsGroupPie,
    BoxDemographicsTrends,
    GenderTable
  },

  data() {
    return {
      lastTimeStamp: '',
      refreshInterval: null
    };
  },

  computed: {
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getStartingPeriod',
      'getEndingPeriod'
    ]),
    ...mapGetters('user', ['getLocale']),
    ...mapState('demographics', ['demographicsDmg']),

    // ✅ TRANSFORM API DATA HERE
    normalizedZone() {
      if (!this.demographicsDmg || this.demographicsDmg.length === 0) {
        return {}; // return empty object instead of null
      }

      const api = this.demographicsDmg;
      const result: Record<string, any> = {}; // To store multiple stores

      // Group by storeCode
      api.forEach(item => {
        const storeCode = item.storeCode;
        const entrance = item.entrance;

        if (!result[storeCode]) {
          result[storeCode] = {
            summary: { dm: {} },
            zones: {}
          };
        }

        // Add dm values per entrance
        if (!result[storeCode].zones[entrance]) {
          result[storeCode].zones[entrance] = { dm: {} };
        }

        for (const key in item.dm) {
          // Sum per entrance
          result[storeCode].zones[entrance].dm[key] =
            (result[storeCode].zones[entrance].dm[key] || 0) + item.dm[key];

          // Sum for store summary
          result[storeCode].summary.dm[key] =
            (result[storeCode].summary.dm[key] || 0) + item.dm[key];
        }
      });

      return result;
    }
  },

  watch: {
    demographicsDmg(newValue) {
      // console.log('API Normalized:', this.normalizedZone);
    }
  },

  mounted() {
    Vue.prototype?.$mixpanel?.track('demographics_report', {
      referrer: document.referrer
    });

    this.startAutoRefresh();
  },

  methods: {
    ...mapActions('demographics', ['fetchDemographicsFidaAll']),

    refreshPage() {
      this.lastTimeStamp = Date.now();
      this.clearAutoRefresh();

      if (this.lastTimeStamp != '') {
        this.fetchDemographicsFidaAll({
          storeCodes: this.getStoreCodesList,
          startDate: this.getStartingPeriod,
          endDate: this.getEndingPeriod,
          type: this.periodType
        });
        localStorage.setItem('FirstTime', '0');
      }
    },

    startAutoRefresh() {
      this.refreshInterval = setInterval(() => {
        if (!this.lastTimeStamp) {
          this.refreshPage();

          localStorage.setItem('reload', '1');
          this.fetchDemographicsFidaAll({
            storeCodes: this.getStoreCodesList,
            startDate: this.getStartingPeriod,
            endDate: this.getEndingPeriod,
            type: this.periodType
          });
          localStorage.setItem('FirstTime', '0');
        }
      }, 2000);
    },

    clearAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
    }
  }
});
